import Storage from "@/utils/storage";
import * as Enums from '@/utils/enums';
import { colors, shadows } from "@/theme";
import PageContext from "@/utils/page-context";
import { useContext, useState, useEffect } from "react";
import NoSSR from "@/utils/no-ssr";
import {Burger, Flex} from "@mantine/core";

export default function SCMobileHeader({ customerZone }: any) {

    const pageContext = useContext(PageContext);
    const [tenantName, setTenantName] = useState(customerZone ? (pageContext as any).tenantName : Storage.getCookie(Enums.Cookie.servCompanyName));

    useEffect(() => {
        setTenantName(customerZone ? (pageContext as any).tenantName : Storage.getCookie(Enums.Cookie.servCompanyName));
    }, [(pageContext as any).tenantName]);

    const [xpanded, setXpanded] = useState((pageContext as any).mobileSidebarExpanded)

    useEffect(() => {
        setXpanded((pageContext as any).mobileSidebarExpanded)
    }, [(pageContext as any).mobileSidebarExpanded]);

    return (<NoSSR>
        <div className="header">
            {
            }
            <Flex
                align={'center'}
                gap={'lg'}
            >
                <Burger
                    ml={'sm'}
                    onClick={() => {
                        setXpanded((p: any) => {
                            (pageContext as any).setMobileSidebarExpanded(!p);
                            return !p
                        });
                    }}
                    opened={xpanded}
                    size={20}
                />
                <div className="tenant-name-container">
                    <h2 className="tenant-name">
                        {tenantName}
                    </h2>
                </div>
            </Flex>
        </div>

        <style jsx>{`

            .header {
                overflow: hidden;
                overflow-wrap: break-word;
                background: ${colors.white};
                padding: 0;
                display: flex;
                box-shadow: ${shadows.cardSmall};
                z-index: 1;
                position: relative;
            }

            .hamburger {
                margin-left: 0.5rem;
                margin-top: 0.5rem;
            }

            .tenant-name-container {
                //display: inline-block;
            }

            h2.tenant-name {
                //display: inline-block;
                //margin: 1rem 0 0 0.5rem;
                font-size: 1.1rem;
                //vertical-align: top;
            }

        `}</style>
    </NoSSR>);
};
